import { FC, ReactNode } from 'react';

import { LogoType, LanguageSwitcher } from '../../ui';
import { DarkModeSwitcherMini } from 'DarkModeProvider';

import styles from './index.module.scss';


type SignUpLayoutProps = {
	children: ReactNode;
};

export const Login2FALayout: FC<SignUpLayoutProps> = ({ children }) => {
	return (
		<div className={styles.root}>
			<div className={styles.header}>
				<LogoType />
				<div className={styles.controls}>
					<LanguageSwitcher />
					<DarkModeSwitcherMini />
				</div>
			</div>
			<div className={styles.body}>
				<div className={styles.center}>
					<div className={styles.content}>
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};
